import { useTheme } from '@/theme';
import { ThemeIds } from '@/theme/themes';
import { useEffect } from 'react';

interface AchievementIconProps {
    icon: string;
    onLoaded?: () => void;
}

export default function AchievementIcon({ icon, onLoaded }: AchievementIconProps) {
    const { themeId } = useTheme();

    let src = '';
    if (achievementIcon[themeId] && achievementIcon[themeId][icon]) {
        src = achievementIcon[themeId][icon];
    } else if (icon) {
        console.error('Showing fallback achievement icon');
        src = '/assets/global/images/achievements/info.webp';
    }

    useEffect(() => {
        if (!onLoaded) return;
        const img = new Image();
        img.src = src;
        if (img.complete) {
            setTimeout(onLoaded, 0);
        } else {
            img.onload = onLoaded;
        }
    }, [icon, onLoaded]);

    if (!src) return <></>;
    return <img src={src} alt=" " />;
}

const defaultIcons = {
    points: '/assets/global/images/achievements/points.webp',
    death: '/assets/global/images/achievements/death.webp',
    default: '/assets/global/images/achievements/default.webp',
    info: '/assets/global/images/achievements/info.webp',
    event: '/assets/global/images/achievements/info.webp',
};

const achievementIcon = {
    [ThemeIds.Titan]: {
        ...defaultIcons,
        event: '/assets/global/images/achievements/death.webp',
    },
    [ThemeIds.Phobos]: defaultIcons,
    [ThemeIds.Hyperion]: {
        ...defaultIcons,
        event: '/assets/themes/hyperion/images/achievements/event.png',
    },
    [ThemeIds.Mimas]: {
        ...defaultIcons,
        default: '/assets/themes/mimas/images/achievements/default.webp',
    },
    [ThemeIds.Deimos]: {
        ...defaultIcons,
        default: '/assets/themes/deimos/images/achievements/default.webp',
    },
    [ThemeIds.Umbra]: {
        ...defaultIcons,
        default: '/assets/themes/umbra/images/achievements/default.webp',
    },
    [ThemeIds.Rana]: defaultIcons,
};
